import NarrowItemCard from './narrowItemCard'

export default NarrowItemCard
